import { logError } from '../'

const manageErrorCodeMsg: string[] = [
  'E0000004',
  'E0000095',
  'E0000105',
  'E0000068',
  'E0000069',
  'E0000119',
  'E0000011',
  'E0000082',
]

export const errorMsg: any = {
  requiredField(label: string) {
    return `${label} is a required field.`
  },
}

export const getErrorMsg = (key: string): string => errorMsg[key]

export const processErrorMsg = (
  error: any,
  module: string,
  moduleDescription?: string | null,
  verbose: boolean = true,
) => {
  let msg: string = 'Something went wrong! '

  /**
   * If no error object
   */
  if (!error) {
    if (verbose) {
      logError({ customMessage: msg }, module, moduleDescription)
      console.error(msg)
    }
    return msg
  }

  /**
   * Log the error
   */
  if (verbose) {
    logError(error, module, moduleDescription)
    console.error(error)
  }

  if (error.response?.status === 403) {
    const url = error.config?.url || ''
    const message = error.response?.data?.message || ''

    if (
      url.includes('/resend') ||
      message.toLowerCase().includes('rate limit')
    ) {
      return 'Too many attempts. Please wait a few minutes before trying again.'
    }

    if (message.toLowerCase().includes('old password is not correct')) {
      return 'The old password entered is incorrect. Please try again.'
    }

    if (message.toLowerCase().includes('password has been used too recently')) {
      return 'The password has been used recently. Please try again.'
    }

    return 'Access denied. Please try again or contact support.'
  }

  if (error.response?.status === 429) {
    return 'Too many attempts. Please wait a few minutes before trying again.'
  }

  if (error.response?.data?.message) {
    const apiMessage = error.response.data.message.toLowerCase()

    if (
      apiMessage.includes('invalid phone number') ||
      (apiMessage.includes('phone number') && apiMessage.includes('invalid'))
    ) {
      return 'Please enter a valid phone number including the area code.'
    }

    if (apiMessage.includes('factorenrollrequest')) {
      return 'Invalid enrollment information. Please check your input and try again.'
    }

    return error.response.data.message
  }

  if (error.response?.data?.errorSummary) {
    const oktaError = error.response.data
    const errorCausesSummary =
      oktaError.errorCauses?.map((e: any) => e.errorSummary).join(' ') || ''
    const combinedMessage =
      `${oktaError.errorSummary} ${errorCausesSummary}`.toLowerCase()

    if (
      combinedMessage.includes('invalid phone number') ||
      (combinedMessage.includes('phone number') &&
        combinedMessage.includes('invalid'))
    ) {
      return 'Please enter a valid phone number including the area code.'
    }

    if (combinedMessage.includes('factorenrollrequest')) {
      return 'Invalid enrollment information. Please check your input and try again.'
    }
  }

  /**
   * Error object not of Okta
   */

  if (!error.errorSummary && error.message) return error.message

  /**
   * Displaying custom message for user
   */

  const foundErrorCode = manageErrorCodeMsg.find(
    (errorCode: string) => errorCode === error.errorCode,
  )

  if (foundErrorCode) return foundErrorCode

  if (error.errorSummary || error.errorCauses?.length) {
    const errorCausesSummary =
      error.errorCauses?.map((e: any) => e.errorSummary).join(' ') || ''
    const combinedMessage =
      `${error.errorSummary || ''} ${errorCausesSummary}`.toLowerCase()

    if (
      combinedMessage.includes('invalid phone number') ||
      (combinedMessage.includes('phone number') &&
        combinedMessage.includes('invalid'))
    ) {
      return 'Please enter a valid phone number including the area code.'
    }

    if (combinedMessage.includes('factorenrollrequest')) {
      return 'Invalid enrollment information. Please check your input and try again.'
    }
  }

  msg = (error.errorSummary && error.errorSummary + '. ') || msg

  if (error.errorCauses && error.errorCauses.length) {
    for (let e of error.errorCauses) {
      msg += e.errorSummary + '. '
    }
  }

  /**
   * if double dots appears after concatenation in above then replace it to one dot.
   * This inconsistency is in okta error message where sometime dot appear and
   * sometimes not!
   */
  const formattedError = msg.split('..').join('.')
  if (verbose) {
    console.error(formattedError)
  }

  return formattedError
}
